<template>
  <div id="app">
    <div v-if="iosflag == 1" class="arreement">
     <h3>学习乐</h3>
      <p class="desc">学习乐——可以私密聊天的背单词软件，新一代的熟人社交平台。
      </p><p class="desc">学习乐期望让人们在繁杂的社会活动中拥有一方净土，建立真实、有效、健康的社交关系。避免无用社交，保护您的私人空间，以确保在这个平台只出现你最重要的人！为此，我们增加了添加好友的难度：
        </p><p class="title_small">- 不收集与匹配通讯录
      </p><p class="desc">我们不收集您的通讯录，这样就无法通过社交关系向你推荐好友。你的好友也不会知道你正在使用智能计算器。以确保聊天的安全性。
        </p> <p class="title_small">- 仅支持通过密友号添加好友
      </p><p class="desc">注册完成后，我们会生成您的专属密友号，仅能通过密友号添加好友。通过手机号、昵称等其他条件无法查找到。以确保交流的私密性。
      </p><p class="desc">在体验上，我们提供了聊天应有的全部功能，可以通过文字、图片、视频、语音进行交流互动。同时我们也为您和您的好友提供了一个共享的私密空间相册。在此基础上，为了您聊天的私密性，我们还提供了更多的实用功能：翻转返回、保密时段、消息集合等。我们所做的一切努力都希望您能安全放心的聊天。
      </p><p class="desc">学习乐——安全、私密、有温度。但它也注定只是一小部分人的专属聊天APP，但我们却因此而感到荣幸，因为总要有人去满足小众的需求。</p>
    </div>
    <div v-if=" iosflag == 0">
      <div v-if="showFlag == 1" class="arreement">
        <p class="desc">智能计算器是“好运吧”私密聊天软件中的经典系列。这是一款熟人社交软件，致力于为您提供一个安全、纯洁、无干扰的聊天环境。</p>
        <p
          class="desc"
        >智能计算器期望让人们在繁杂的社会活动中拥有一方净土，建立真实、有效、健康的社交关系。避免无用社交，保护您的私人空间，以确保在智能计算器只出现你最重要的人！为此，我们增加了添加好友的难度：</p>
        <p class="title_small">- 不收集与匹配通讯录</p>
        <p class="desc">我们不收集您的通讯录，这样就无法通过社交关系向你推荐好友。你的好友也不会知道你正在使用智能计算器。以确保聊天的安全性。</p>
        <p class="title_small">- 仅支持通过聊天号添加好友</p>
        <p class="desc">注册完成后，我们会生成您的专属聊天号，仅能通过聊天号添加好友。通过手机号、昵称等其他条件无法查找到。以确保交流的私密性。</p>
        <p
          class="desc"
        >在体验上，我们提供了聊天应有的全部功能，可以通过文字、图片、视频、语音进行交流互动。同时我们也为您和您的好友提供了一个共享的私密空间相册。在此基础上，为了您聊天的私密性，我们还提供了更多的实用功能：翻转返回、保密时段、消息集合等。我们所做的一切努力都希望您能安全放心的聊天。</p>
        <p class="desc">智能计算器是新一代的社交平台-安全、私密、有温度。但它也注定只是一小部分人的专属聊天APP，但我们却因此而感到荣幸，因为总要有人去满足小众的需求。</p>
      </div>
      <div v-else-if="showFlag == 2" class="arreement">
        <p class="desc">
          {{appName}}是一款熟人社交应用，致力于为您提供一个纯洁无干扰的聊天环境。{{appName}}最适合于情侣之间、闺蜜之间聊天使用，因为就是这么独一无二。
          为此，我们增加了添加好友的难度：
        </p>
        <p class="title_small">- 仅支持通过聊天号添加好友</p>
        <p class="desc">注册完成后，我们会生成您的专属聊天号，仅能通过聊天号添加好友。通过手机号、昵称等其他条件无法查找到。这能确保了交流的私密性。</p>
        <p class="title_small">- 不收集与匹配通讯录</p>
        <p class="desc">我们不收集您的通讯录，这样就无法通过社交关系向你推荐好友。你的好友也不会知道你正在使用{{appName}}。</p>
        <p
          class="desc"
        >我们提供了聊天应有的全部功能，可以通过文字、图片、视频、语音进行交流互动。建立真实、有效、健康的社交关系。避免无用社交，保护您的私人空间，以确保在{{appName}}只出现你最重要的人！</p>
        <p
          class="desc"
        >{{appName}}期望让人们在繁杂的社会活动中拥有一方净土，是与最重要的人共享亲密空间。请使用{{appName}}与您最重要的人进行聊天，这样可以在第一时间响应新信息提醒。</p>
        <p class="desc">{{appName}}注定只是一小部分人的专属聊天APP，但我们却因此而感到荣幸。因为总要有人去满足小众的需求。</p>
      </div>
      <div v-else class="arreement">
        <p class="desc">{{appName}}——伪装私密聊天APP，新一代的熟人社交平台。</p>
        <p
          class="desc"
        >好运吧旗下有各种类型的伪装聊天APP，为了让您的聊天更私密和安全，我们给您的聊天添加了伪装外壳。其中常见的类型包括：工具类（智能计算器等）、资讯类（天下事等）、学习办公类、游戏类。根据你的自身情况和使用习惯，在这里你能找到最适合您的伪装聊天神器。</p>
        <p
          class="desc"
        >好运吧期望让人们在繁杂的社会活动中拥有一方净土，建立真实、有效、健康的社交关系。避免无用社交，保护您的私人空间，以确保在这个平台只出现你最重要的人！为此，我们增加了添加好友的难度：</p>
        <p class="title_small">- 不收集与匹配通讯录</p>
        <p class="desc">我们不收集您的通讯录，这样就无法通过社交关系向你推荐好友。你的好友也不会知道你正在使用智能计算器。以确保聊天的安全性。</p>
        <p class="title_small">- 仅支持通过聊天号添加好友</p>
        <p class="desc">注册完成后，我们会生成您的专属聊天号，仅能通过聊天号添加好友。通过手机号、昵称等其他条件无法查找到。以确保交流的私密性。</p>
        <p
          class="desc"
        >在体验上，我们提供了聊天应有的全部功能，可以通过文字、图片、视频、语音进行交流互动。同时我们也为您和您的好友提供了一个共享的私密空间相册。在此基础上，为了您聊天的私密性，我们还提供了更多的实用功能：翻转返回、保密时段、消息集合等。我们所做的一切努力都希望您能安全放心的聊天。</p>
        <p class="desc">好运吧——安全、私密、有温度。但它也注定只是一小部分人的专属聊天APP，但我们却因此而感到荣幸，因为总要有人去满足小众的需求。</p>
      </div>
    </div>
  </div>
</template>
<script>
import store from "@/store";
import util from "@/utils/util";

export default {
  name: "app",
  data() {
    return {
      msg: "好运吧关于",
      appName: "好运吧关于",
      showFlag: 0,
      iosflag: 1
    };
  },
  mounted() {
    this.$point.init(new Date());
    store.dispatch("hideLoading");

    var appName = util.getUrlParam("appName");
    if (appName) {
      this.appName = appName;
    }

    if (appName == "智能计算器") {
      this.showFlag = 1;
    } else if (appName == "亲密聊") {
      this.showFlag = 2;
    }

    var u = navigator.userAgent;
    console.log(u.indexOf("T00991"))
    if (u.indexOf("T00991") > -1) {
      this.iosflag =1;

    } else {
      this.iosflag = 0;
    }
    if (appName == "学习乐") {
        this.iosflag =1;
    } else {
        this.iosflag = 0;
    }
  },

};
</script>
<style  scoped>
#app {
  width: 750px;
  height: 1334px;
}

.arreement {
  padding: 32px 58px 80px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(48, 48, 48, 1);
  line-height: 40px;
}

.arreement h3 {
  width: 610px;
  height: 50px;
  font-size: 36px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  color: rgba(48, 48, 48, 1);
  line-height: 50px;
}
.arreement p {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(48, 48, 48, 1);
  line-height: 40px;
  text-align: left;
  text-indent: 40px;
}
.arreement .arreement .title {
  text-align: left;
  padding-bottom: 30px;
  font-weight: bold;
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
  color: rgba(48, 48, 48, 1);
  line-height: 44px;
}
.arreement .title_small {
  padding-top: 20px;
  line-height: 0px;
}

.arreement span {
  text-align: left;
}

.arreement .bold {
  font-weight: bold;
}
.arreement .text_line {
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/app/qml/about/about.vue